import React from 'react';
import Projects from '../components/Projects';
import CtaBanner from '../components/CtaBanner';
import { useScrollReveal } from '../hooks/useScrollReveal';

function ProjectsPage() {
  useScrollReveal();
  return (
    <main className="page">
      <Projects />
      <CtaBanner />
    </main>
  );
}

export default ProjectsPage;
